
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { ROLES } from '@/utils/constants';
import { toErrorMessage } from '@/utils/errorHandling';
import Toast from '@/utils/toast';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import SelectComponent from '@/components/shared/Select.vue';

@Component<ChangeRoleModal>({
	components: {
		StandardModal,
		SelectComponent
	}
})
export default class ChangeRoleModal extends Vue {
	@Action('bulkUpdateRoles', { namespace: 'users' }) private bulkUpdateRoles!: (payload: { userIds: string[]; role: string; }) => Promise<BulkUserActionResult | void>;
	@Getter('getRoleLevel', { namespace: 'auth' }) private roleLevel!: number;
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Array, default: () => [] }) private userIds!: string[];

	private selectedRole: string = '';
	private isSubmitting: boolean = false;
	private count: number = this.userIds.length;
	private bulkSummary: BulkUserActionResult | null = null;

	private get roleOptions(): { text: string; value: string }[] {
		return Object.keys(ROLES)
			// Admins can assign any role.
			// Everyone else only sees roles lower than them, and never the staff/kiosk roles.
			.filter(role => {
				if (this.roleLevel === ROLES.admin) {
					return true;
				}
				const level = ROLES[role as keyof Roles];
				return level > this.roleLevel && level < ROLES.staff;
			})
			.map(role => ({
				text: this.$t(`multi_location_settings.user_management.roles.${role}`),
				value: role
			}));
	}

	/**
	 * Submit the bulk role change and display a summary.
	 *
	 * @return {Promise<void>}
	 */
	private async confirm(): Promise<void> {
		this.isSubmitting = true;
		try {
			const bulkSummary = await this.bulkUpdateRoles({ userIds: this.userIds, role: this.selectedRole });
			if (bulkSummary) {
				this.bulkSummary = bulkSummary;
			}
		}
		catch (error) {
			Toast.error(this.$tc('multi_location_settings.user_management.change_role_modal.error_changing', this.count, { errorMessage: toErrorMessage(error) }));
		}
		finally {
			this.isSubmitting = false;
		}
	}
}
